export * from './ai-umc.service';
